<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Pedidos', 'link' : '/orders' }]"
    />

    <div class="row">
      <div class="col-12">
        <h1>Vitrine online</h1>
        <p class="text-muted">Link público onde o cliente escolhe a data, monta o pedido e envia pelo WhatsApp.</p>
      </div>
    </div>
    <hr/>

    <div v-if="loading" class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <form v-else @submit.prevent="salvar" class="row">
      <div class="col-lg-8">
        <div class="form-check form-switch mb-4">
          <input v-model="dados.showcase_enabled" class="form-check-input" type="checkbox" role="switch" id="chkEnabled">
          <label class="form-check-label" for="chkEnabled"><strong>Vitrine ativa</strong></label>
        </div>

        <!-- Aparência -->
        <div class="card mb-4">
          <div class="card-body">
            <h6 class="card-title mb-3">Aparência</h6>

            <div class="d-flex flex-wrap align-items-center gap-3 mb-4">
              <div class="sv-logo">
                <img v-if="logo" :src="logo" alt="Foto de perfil da empresa">
                <i v-else class="bi bi-image"></i>
              </div>
              <div>
                <div class="fw-semibold mb-1">Foto de perfil</div>
                <div class="d-flex flex-wrap gap-2">
                  <label class="btn btn-sm btn-outline-primary mb-0" :class="{ disabled: enviandoLogo }">
                    <span v-if="enviandoLogo" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <i v-else class="bi bi-upload me-1"></i>{{ logo ? 'Trocar foto' : 'Enviar foto' }}
                    <input type="file" accept="image/png,image/jpeg,image/webp" class="d-none" @change="enviarLogo" :disabled="enviandoLogo">
                  </label>
                  <button v-if="logo" type="button" class="btn btn-sm btn-outline-danger" @click="removerLogo" :disabled="enviandoLogo">Remover</button>
                </div>
                <small class="text-muted d-block mt-1">PNG, JPG ou WebP até 2 MB. De preferência quadrada.</small>
              </div>
            </div>

            <label class="fw-semibold d-block mb-2" for="corVitrine">Cor do topo</label>
            <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
              <button v-for="c in CORES_SUGERIDAS" :key="c" type="button" class="sv-swatch" :class="{ active: corAtual === c }"
                :style="{ background: c }" @click="dados.showcase_color = c" :aria-label="'Usar a cor ' + c"></button>
              <input :value="corAtual" @input="dados.showcase_color = $event.target.value" type="color" class="form-control form-control-color" id="corVitrine" title="Escolher outra cor">
              <button v-if="dados.showcase_color" type="button" class="btn btn-sm btn-link" @click="dados.showcase_color = null">Usar padrão</button>
            </div>

            <!-- Prévia do topo da vitrine -->
            <div class="sv-preview" :style="tema" aria-hidden="true">
              <div class="sv-preview-logo">
                <img v-if="logo" :src="logo" alt="">
                <span v-else>{{ iniciais }}</span>
              </div>
              <div>
                <div class="sv-preview-name">{{ nomeEmpresa || 'Sua locadora' }}</div>
                <div class="sv-preview-sub">Prévia do topo da vitrine</div>
              </div>
              <span class="sv-preview-btn">Ver disponíveis</span>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="txtSlug">Endereço da vitrine:</label>
          <div class="input-group">
            <span class="input-group-text">{{ baseUrl }}/v/</span>
            <input v-model="dados.slug" @input="normalizarSlug" required type="text" maxlength="80" class="form-control" id="txtSlug" placeholder="minha-locadora">
          </div>
          <small class="text-muted">Use só letras minúsculas, números e hífen.</small>
        </div>

        <div class="form-group mb-3">
          <label for="txtWhats">WhatsApp que recebe os pedidos:</label>
          <input v-model="dados.whatsapp" type="text" maxlength="20" class="form-control" id="txtWhats" placeholder="(51) 99999-9999">
        </div>

        <div class="form-group mb-3">
          <label for="txtMsg">Mensagem de boas-vindas:</label>
          <textarea v-model="dados.showcase_message" maxlength="2000" rows="3" class="form-control" id="txtMsg" placeholder="Ex.: Atendemos Porto Alegre e região. Entrega e montagem inclusas."></textarea>
        </div>

        <div class="form-group mb-4">
          <label for="txtSetup">Intervalo padrão entre festas (minutos):</label>
          <input v-model.number="dados.setup_minutes" type="number" min="0" max="1440" class="form-control" id="txtSetup">
          <small class="text-muted">Tempo de recolhimento, transporte e montagem. O item fica bloqueado esse tempo antes e depois de cada locação (pode ser ajustado por item no estoque).</small>
        </div>

        <div class="form-group mb-4">
          <label for="txtPix">Desconto no Pix (%):</label>
          <input v-model.number="dados.pix_discount_percent" type="number" min="0" max="100" step="0.01" class="form-control" id="txtPix">
          <small class="text-muted">Aplicado automaticamente quando o cliente escolhe pagar via Pix na vitrine. Use 0 para não oferecer.</small>
        </div>

        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Salvar
        </button>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Link da vitrine</h6>
            <p class="small text-break mb-2">{{ linkVitrine }}</p>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm btn-outline-primary" @click="copiar" :disabled="!salvo.showcase_enabled">
                <i class="bi bi-clipboard me-1"></i>Copiar
              </button>
              <a class="btn btn-sm btn-outline-secondary" :class="{ disabled: !salvo.showcase_enabled }" :href="linkVitrine" target="_blank" rel="noopener">
                <i class="bi bi-box-arrow-up-right me-1"></i>Abrir
              </a>
            </div>
            <p v-if="!salvo.showcase_enabled" class="small text-muted mt-2 mb-0">Ative e salve a vitrine para compartilhar o link.</p>
          </div>
        </div>
      </div>
    </form>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive, computed } from 'vue';
import { tenant } from '@/models/tenant';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import { useAuth } from '@/services/auth';
import { temaVitrine, CORES_SUGERIDAS, COR_PADRAO } from '@/utils/showcaseTheme';

export default {
  name: "ShowcaseSettingsView",
  components: {
    PainelLayout,
    Breadcrumb
  },
  setup() {

    const toastStore = useToastStore();
    const model = tenant();
    const loading = ref(false);
    const saving = ref(false);
    const baseUrl = window.location.origin;

    const dados = reactive({
      slug: '',
      whatsapp: '',
      showcase_enabled: false,
      showcase_message: '',
      setup_minutes: 0,
      pix_discount_percent: 0,
      showcase_color: null
    });
    const logo = ref(null);
    const nomeEmpresa = ref('');
    const enviandoLogo = ref(false);
    const auth = useAuth();

    const corAtual = computed(() => dados.showcase_color || COR_PADRAO);
    const tema = computed(() => temaVitrine(corAtual.value));
    const iniciais = computed(() => nomeEmpresa.value.split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join(''));
    // Estado salvo no servidor: o link só vale depois de salvar
    const salvo = reactive({ slug: '', showcase_enabled: false });

    const linkVitrine = computed(() => `${baseUrl}/v/${salvo.slug || dados.slug}`);

    function preencher(t) {
      dados.slug = t.slug ?? '';
      dados.whatsapp = t.whatsapp ?? '';
      dados.showcase_enabled = !!t.showcase_enabled;
      dados.showcase_message = t.showcase_message ?? '';
      dados.setup_minutes = t.setup_minutes ?? 0;
      dados.pix_discount_percent = Number(t.pix_discount_percent ?? 0);
      dados.showcase_color = t.showcase_color ?? null;
      logo.value = t.logo || null;
      nomeEmpresa.value = t.name ?? '';
      salvo.slug = dados.slug;
      salvo.showcase_enabled = dados.showcase_enabled;
    }

    function normalizarSlug() {
      dados.slug = dados.slug
        .toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9-]+/g, '-')
        .replace(/-{2,}/g, '-');
    }

    async function salvar() {
      saving.value = true;
      try {
        dados.slug = dados.slug.replace(/^-+|-+$/g, '');
        preencher(await model.update({ ...dados }));
        toastStore.success('Vitrine atualizada.');
      } catch (error) {
        toastStore.error('Erro ao salvar: ' + parseError(error));
      }
      saving.value = false;
    }

    // Mantém o logo do painel (guardado no login) igual ao da empresa
    function atualizarLogoSessao(url) {
      if (auth.tenant) auth.setTenant(JSON.stringify({ ...auth.tenant, logo: url }));
    }

    async function enviarLogo(evento) {
      const arquivo = evento.target.files?.[0];
      evento.target.value = '';
      if (!arquivo) return;
      if (arquivo.size > 2 * 1024 * 1024) {
        toastStore.warning('A imagem precisa ter até 2 MB.');
        return;
      }
      enviandoLogo.value = true;
      try {
        const t = await model.uploadLogo(arquivo);
        logo.value = t.logo;
        atualizarLogoSessao(t.logo);
        toastStore.success('Foto de perfil atualizada.');
      } catch (error) {
        toastStore.error('Erro ao enviar a foto: ' + parseError(error));
      }
      enviandoLogo.value = false;
    }

    async function removerLogo() {
      if (!confirm('Remover a foto de perfil?')) return;
      enviandoLogo.value = true;
      try {
        await model.update({ logo: null });
        logo.value = null;
        atualizarLogoSessao('');
        toastStore.success('Foto removida.');
      } catch (error) {
        toastStore.error(parseError(error));
      }
      enviandoLogo.value = false;
    }

    async function copiar() {
      try {
        await navigator.clipboard.writeText(linkVitrine.value);
        toastStore.success('Link copiado.');
      } catch (e) {
        toastStore.warning('Não foi possível copiar. Selecione o link e copie manualmente.');
      }
    }

    onMounted(async () => {
      loading.value = true;
      try {
        preencher(await model.getOne());
      } catch (error) {
        toastStore.error('Erro ao carregar dados da empresa: ' + parseError(error));
      }
      loading.value = false;
    });

    return {
      dados, salvo, loading, saving, baseUrl, linkVitrine, normalizarSlug, salvar, copiar,
      logo, nomeEmpresa, enviandoLogo, corAtual, tema, iniciais, enviarLogo, removerLogo, CORES_SUGERIDAS
    }
  }
}
</script>

<style scoped>
.sv-logo {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  background: #f8f9fb;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #9ca3af;
  font-size: 1.6rem;
}

.sv-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.sv-swatch {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px #d1d5db;
  padding: 0;
}

.sv-swatch.active {
  box-shadow: 0 0 0 2px #111827;
}

.sv-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  border-radius: 14px;
  padding: 16px;
  color: #fff;
  background: linear-gradient(135deg, var(--sc-accent), var(--sc-accent-2));
}

.sv-preview-logo {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--sc-accent);
  font-weight: 800;
}

.sv-preview-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}

.sv-preview-name {
  font-weight: 800;
  font-size: 1.1rem;
  line-height: 1.1;
}

.sv-preview-sub {
  font-size: .8rem;
  opacity: .85;
}

.sv-preview-btn {
  margin-left: auto;
  background: rgba(255, 255, 255, .2);
  border: 1px solid rgba(255, 255, 255, .4);
  border-radius: 10px;
  padding: 6px 12px;
  font-size: .85rem;
  font-weight: 700;
}
</style>
